import React from 'react'

const RedoIcon = ({color = 'currentColor', width = 20, height = 20, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M15 8.33333H6.66667C4.82572 8.33333 3.33333 9.82572 3.33333 11.6667C3.33333 13.5076 4.82572 15 6.66667 15H10"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.5 11.6667L15.8333 8.33333L12.5 5"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default RedoIcon
